export const APPLE_STORE_URL = 'https://apps.apple.com/us/app/myconnect-vpn-super-unlimited/id6747254639';
export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=ai.myvpn.app';

export default {
    methods: {
        openApple() {
            window.open(APPLE_STORE_URL, '_blank');
        },
        openAndroid() {
            ym(101875098, 'reachGoal', 'chrome');
            window.open(ANDROID_STORE_URL, '_blank');
        },
        openStore() {
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                this.openApple();
            } else {
                this.openAndroid();
            }
        },
    },
};
